//const ukHolidays = ['2024-12-25', '2024-12-26'];
const ukHolidays = window.ukHolidays?.holidayDates.split(',');
function isUkHoliday(date) {
    if (!(date instanceof Date) || isNaN(date)) {
        return false;
    }
    const dateString = date.toISOString().split('T')[0];
    return ukHolidays.includes(dateString);
}

function getNextWorkingDay(date) {
    date.setDate(date.getDate() + 1);
    while (date.getDay() === 0 || date.getDay() === 6 || isUkHoliday(date)) {
        date.setDate(date.getDate() + 1);
    }
    return date;
}

function addWorkingDays(startDate, days) {
    let date = new Date(startDate);
    while (days > 0) {
        date = getNextWorkingDay(date);
        days--;
    }
    return date;
}

function formatDateWithComma(date) {
    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    const parts = date.toLocaleDateString('en-GB', options).split(' ');
    return `${parts[0]}, ${parts[1]} ${parts[2]}`;
}

function calculateDeliveryEstimate() {
    const ukTime = new Date();
    const cutoffTime = new Date(ukTime);
    cutoffTime.setHours(19, 30, 0, 0); 
    
    let shippingDate = new Date(ukTime);

    if (ukTime.getTime() > cutoffTime.getTime()) {
        shippingDate = getNextWorkingDay(shippingDate); 
        shippingDate = getNextWorkingDay(shippingDate);
    } else {
        shippingDate = getNextWorkingDay(shippingDate); 
    }

    const firstDeliveryDate = addWorkingDays(shippingDate, 1); 
    const lastDeliveryDate = addWorkingDays(shippingDate, 3);  

    const firstDateFormatted = formatDateWithComma(firstDeliveryDate);
    const lastDateFormatted = formatDateWithComma(lastDeliveryDate);

    let shippingMain = document.querySelector('.cw-shippingTime .cw-text');
    if(firstDateFormatted) document.getElementById('first_delivery_date').innerHTML = firstDateFormatted;
    if(lastDateFormatted) document.getElementById('sec_delivery_date').innerHTML = lastDateFormatted;
}
calculateDeliveryEstimate()